import React, { useContext, useState } from 'react';
import classNames from 'classnames';

import PropTypes from 'prop-types';
import formStyle from '../../../../scss/components/form.module.scss';
import buttonStyle from '../../../../scss/components/buttons/button.module.scss';
import { MessageContext } from '../../Context/MessageContext';
import axiosInstance from '../../../Services/axios';

const APP_URL = import.meta.env.VITE_APP_URL;

const ShareArticle = ({ entity }) => {
    const { pushMessage } = useContext(MessageContext);

    const [expiration, setExpiration] = useState('24');
    const [shareLink, setShareLink] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);
    const [isCopied, setIsCopied] = useState(false);

    const handleGenerateLink = async () => {
        setIsGenerating(true);
        setIsCopied(false);

        try {
            const article = entity.id;
            const url = `${APP_URL}admin/articles/${article}/share-link`;
            const response = await axiosInstance.post(url, {
                expires_in_hours: Number(expiration),
            });
            setShareLink(response.data.url);
        } catch (error) {
            pushMessage({
                title: 'Failed to generate share link',
            });

            setShareLink('');
        } finally {
            setIsGenerating(false);
        }
    };

    const handleCopy = async () => {
        if (!shareLink) {
            return;
        }

        try {
            await navigator.clipboard.writeText(shareLink);
            setIsCopied(true);
        } catch (error) {
            pushMessage({
                title: error.message,

            });
        }
    };

    return (
        <div className={formStyle.panel}>
            <div className="flex items-end gap-4 mb-4 mt-4">
                <div className="flex-2">
                    <label
                        className={formStyle.label}
                        htmlFor="share-link-expiration"
                    >
                        Share Link Expiration
                    </label>
                    <select
                        id="share-link-expiration"
                        value={expiration}
                        onChange={(event) => setExpiration(event.target.value)}
                        className={formStyle.select}
                    >
                        <option value="24">24 hours</option>
                        <option value="48">48 hours</option>
                        <option value="72">72 hours</option>
                    </select>
                </div>

                <button
                    type="button"
                    onClick={handleGenerateLink}
                    disabled={isGenerating}
                    className={classNames(
                        buttonStyle.basic,
                        'whitespace-nowrap',
                    )}
                >
                    {isGenerating ? 'Generating...' : 'Generate share link'}
                </button>
            </div>

            <div className="w-full min-w-0">
                <label className={formStyle.label} htmlFor="share-link-output">
                    Share link
                </label>

                <div className="flex w-full items-center gap-2">
                    <div
                        id="share-link-output"
                        className={classNames(
                            formStyle.formTextInput,
                            'min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap select-all',
                        )}
                        title={shareLink}
                    >
                        {shareLink || 'Generated share link will appear here'}
                    </div>

                    <button
                        type="button"
                        onClick={handleCopy}
                        disabled={!shareLink}
                        className={classNames(
                            buttonStyle.basic,
                            'shrink-0 whitespace-nowrap',
                            !shareLink ? 'opacity-50 cursor-not-allowed' : '',
                        )}
                    >
                        {isCopied ? 'Copied' : 'Copy'}
                    </button>
                </div>
            </div>
        </div>
    );
};

ShareArticle.propTypes = {
    entity: PropTypes.object.isRequired,
};

export default ShareArticle;
